import { projectSlice } from "./project.reducer";

export const { updateProject } = projectSlice.actions;

export default projectSlice.actions;
